'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'CUSTOMER_BY_SSID_PROFILE',
    chartType = 'POINT_IN_TIME',
    filters = [config.filters.DATE],
    dataSeries = {
        SSID_PROFILE_USED: 'ssidProfileUsed',
        GUEST_SSID_PROFILE_USED: 'guestSsidProfileUsed',
        TOTAL_SSID_PROFILE_USED: 'totalSsidProfileUsed',
        ONLY_GUEST_SSID: 'onlyGuestSsid',
        BOTH_GUEST_CORPORATE_SSID: 'bothGuestCorporateSsid',
        ONLY_CORPORATE_SSID: 'onlyCorporateSsid',
        NO_SSID_USED: 'noSsidUsed'
    },
    fieldNames = {
        GUEST_SSID_PROFILE_USED: 'amcNumOfAppliedAuthWlanProfilesWithIsguestFlagSet',
        TOTAL_SSID_PROFILE_USED: 'amcNumOfAppliedAuthWlanProfiles'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: [{
            type: 'longSum',
            name: dataSeries.GUEST_SSID_PROFILE_USED,
            'fieldName': fieldNames.GUEST_SSID_PROFILE_USED
        }, {
            type: 'longSum',
            name: dataSeries.TOTAL_SSID_PROFILE_USED,
            'fieldName': fieldNames.TOTAL_SSID_PROFILE_USED
        }],
        postAggregations: [{
            type: 'javascript',
            name: dataSeries.ONLY_GUEST_SSID,
            fieldNames: [dataSeries.TOTAL_SSID_PROFILE_USED, dataSeries.GUEST_SSID_PROFILE_USED],
            'function': postAggregateOnlyGuest.toString()
        }, {
            type: 'javascript',
            name: dataSeries.BOTH_GUEST_CORPORATE_SSID,
            fieldNames: [dataSeries.TOTAL_SSID_PROFILE_USED, dataSeries.GUEST_SSID_PROFILE_USED],
            'function': postAggregateBothGuestCorporate.toString()
        }, {
            type: 'javascript',
            name: dataSeries.ONLY_CORPORATE_SSID,
            fieldNames: [dataSeries.TOTAL_SSID_PROFILE_USED, dataSeries.GUEST_SSID_PROFILE_USED],
            'function': postAggregateFunctionOnlyCorporate.toString()
        }, {
            type: 'javascript',
            name: dataSeries.NO_SSID_USED,
            fieldNames: [dataSeries.TOTAL_SSID_PROFILE_USED, dataSeries.GUEST_SSID_PROFILE_USED],
            'function': postAggregateFunctionNoProfiles.toString()
        }]
    }],
    dataSeriesFields = ['ssidProfileUsed'],
    modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
    aggregationFields = _.chain(dataSeries).values().without(dataSeries.TIMESTAMP).value(),
    tasks = [
        'durationFilter',
        'druidQueryGenerator',
        'druidQueryValidator',
        'fetchChartData',
        'druidResponseParser',
        'transformResponseToObject', {
            plugin: modifyResponse
        }, {
            name: 'updateChartModelData',
            config: {
                dataSeriesFields: dataSeriesFields,
                modelFieldKeys: modelFieldKeys
            }
        }
    ];

exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.CUSTOMER_SSID_PROFILE;

function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
        computedModel = {},
        guestSsidCount = 0,
        corporateSsidCount = 0,
        bothGuestCorporateSSidCount = 0,
        noSsidCount = 0,
        yValues = [];

    guestSsidCount = $u.charts.sum(model[dataSeries.ONLY_GUEST_SSID]);
    bothGuestCorporateSSidCount = $u.charts.sum(model[dataSeries.BOTH_GUEST_CORPORATE_SSID]);
    corporateSsidCount = $u.charts.sum(model[dataSeries.ONLY_CORPORATE_SSID]);
    noSsidCount = $u.charts.sum(model[dataSeries.NO_SSID_USED]);
    yValues = [guestSsidCount, bothGuestCorporateSSidCount, corporateSsidCount, noSsidCount];
    computedModel[dataSeries.SSID_PROFILE_USED] = [];

    computedModel[dataSeries.SSID_PROFILE_USED].push({
        name: 'Guest',
        y: guestSsidCount
    });

    computedModel[dataSeries.SSID_PROFILE_USED].push({
        name: 'Corporate',
        y: corporateSsidCount
    });

    computedModel[dataSeries.SSID_PROFILE_USED].push({
        name: 'Both',
        y: bothGuestCorporateSSidCount
    });

    computedModel[dataSeries.SSID_PROFILE_USED].push({
        name: 'None',
        y: noSsidCount
    });

    if ($u.charts.allEqualElemArray(yValues, 0) ||
        $u.charts.allEqualElemArray(yValues, null)
    ) {
        context.zeroDataFlag = true;
    }

    context.chartData = computedModel;
    next();
}

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false);

    var yAxisFormatter = $u.charts.chartYaxisFormatter,
        yAxisBaseUnit = '',
        yAxisRoundOff = false,
        yAxisTrimDecimalPlaces = 2,
        nameHeader = 'Network Type',
        yHeader = 'No. Of Customers',
        percentageHeader = '% of Customers';

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            nameHeader: nameHeader,
            yHeader: yHeader,
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces,
            percentageHeader: percentageHeader
        },
        isPie: true,
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var currentContext = this;
                var yMax = _.max(currentContext.series.yData);
                var yValue = currentContext.y;

                var yTooltipUnitObj = yAxisFormatter(yValue, yMax,
                    yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}: <b>{1}</b><br />{2}: <b>{3} {4}</b>',
                    nameHeader,
                    currentContext.point.name,
                    yHeader,
                    yTooltipUnitObj.value,
                    yTooltipUnitObj.unit
                );
            },
            percentageDecimals: 0
        },
        subtitle: {
            text: ''
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance,
            itemStyle: {
                fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
            }
        },
        plotOptions: {
            pie: {
                center: ['50%', '65%'],
                size: 150,
                allowPointSelect: true,
                cursor: 'pointer',
                showInLegend: true,
                colors: [GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
                    GRAPHS.GLOBAL.COLORS.MOJO_RED,
                    GRAPHS.GLOBAL.COLORS.CHART_GREEN,
                    GRAPHS.GLOBAL.COLORS.MOJO_TEAL
                ],
                dataLabels: {
                    enabled: true,
                    crop: false,
                    distance: width / 50,
                    style: {
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                    },
                    connectorColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
                    formatter: function() {
                        if (0 !== this.y)
                            return '<b>' + this.point.name + '</b>: ' + this.percentage.toFixed(2) + ' %';
                    }
                },
                point: {
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    }
                }
            }
        },
        series: [{
            name: 'SSID Profile Usage',
            type: 'pie',
            data: data[dataSeries.SSID_PROFILE_USED]
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}

function postAggregateOnlyGuest(totalProfiles, guestProfiles) {
    if (guestProfiles > 0 && guestProfiles === totalProfiles) {
        return 1;
    } else {
        return 0;
    }
}

function postAggregateBothGuestCorporate(totalProfiles, guestProfiles) {
    if (guestProfiles > 0 && guestProfiles < totalProfiles) {
        return 1;
    } else {
        return 0;
    }
}

function postAggregateFunctionOnlyCorporate(totalProfiles, guestProfiles) {
    if (guestProfiles === 0 && totalProfiles !== 0) {
        return 1;
    } else {
        return 0;
    }
}

function postAggregateFunctionNoProfiles(totalProfiles) {
    if (totalProfiles === 0) {
        return 1;
    } else {
        return 0;
    }
}
